import React, {useEffect, useState} from 'react';
import CreditPayEfficiencyFilters from "../../components/CreditPayEfficiencyFilters/CreditPayEfficiencyFilters";
import FilterContainer from "../../components/FilterContainer/FilterContainer";
import {useTranslation} from "react-i18next";
import RoutesFilters from "../../components/RoutesFilters/RoutesFilters";
import OtherFilters from '../../components/OthersFilters/OtherFilters';
import './SliderFilterDrawerContainer.scss';
import {Button} from '@mui/material';
import Grid from '@mui/material/Grid';
import AppCalendar from '../../components/AppCalendar/AppCalendar';
import { usePairingPackage } from '../../providers/PairingPackage';
import { pairingPackageInitialFilter } from '../PairingPackage/pairingPackageHelper';
import { initialChangedFilters } from './filterHelper';
import { useFilterPreference } from '../../providers/FilterPreference';

const SideFilterDrawerContainer = ({
  changedFilters,
  selectedDate,
  selectedFilters,
  show,  
  setChangedFilters,
  // setFilterData,
  setPairingList,
  setSaveFilters,  
  setSelectedFilters, 
  setToggle,  
}) => {

    const { t } = useTranslation();
    const pairingContext = usePairingPackage();
    const filtersContext = useFilterPreference();
    const [submenuOpen, setSubmenuOpen] = useState({
      cpeOpen: false,
      routesOpen: false,
      dateOpen: false,
      otherOpen: false
    });
    const [displayFilters, setDisplayFilters] = useState(null);

  const handleDisplay = (e) => {
    setSubmenuOpen({
      cpeOpen: false,
      routesOpen: false,
      dateOpen: false,
      otherOpen: false
    })
    // initalize to trigger state update in each child
    // children will update their respective states
    // we handle the filtering in a useEffect :)
    // due to multiple state implementation this is better passed in when
    // we need then having everything here
    setDisplayFilters(e);
    e.preventDefault();
    setToggle(false);
    // setFilterData(true);
  };

  const handleClear = (e) => {  
    setPairingList(pairingContext.pairingPackageData);
    e.preventDefault();
    setSelectedFilters(pairingPackageInitialFilter());
    setChangedFilters(initialChangedFilters());
    if(filtersContext.defaultSearchState) setSaveFilters(true);
  };

  useEffect(() => {
    if (show) {
      return;
    }
    setSubmenuOpen({
      cpeOpen: false,
      routesOpen: false,
      dateOpen: false,
      otherOpen: false
    })
    
  }, [show]);


    return (
      <>
        <div className="slider-content">
          <div>
              <FilterContainer isOpen={submenuOpen.routesOpen} handleClick={() => {setSubmenuOpen({...submenuOpen, routesOpen: !submenuOpen.routesOpen})}} filterName={t('filters.routes.title')} changedFilters={changedFilters} setChangedFilters={setChangedFilters} setSelectedFilters={setSelectedFilters} isLastItem={false} setSaveFilters={setSaveFilters}>
                <RoutesFilters displayFiltersClicked={displayFilters} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters}/>
              </FilterContainer>

              <FilterContainer isOpen={submenuOpen.dateOpen} handleClick={() => {setSubmenuOpen({...submenuOpen, dateOpen: !submenuOpen.dateOpen})}} filterName={t('filters.dateTime.title')} changedFilters={changedFilters} setChangedFilters={setChangedFilters} setSelectedFilters={setSelectedFilters} isLastItem={false} setSaveFilters={setSaveFilters}>
                <AppCalendar displayFiltersClicked={displayFilters} selectedDate={selectedDate} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters}/>
              </FilterContainer>

              <FilterContainer isOpen={submenuOpen.cpeOpen} handleClick={() => {setSubmenuOpen({...submenuOpen, cpeOpen: !submenuOpen.cpeOpen})}} filterName={t('filters.creditPayEfficiency.title')} changedFilters={changedFilters} setChangedFilters={setChangedFilters} setSelectedFilters={setSelectedFilters} isLastItem={false} setSaveFilters={setSaveFilters}>
                <CreditPayEfficiencyFilters displayFiltersClicked={displayFilters} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters}/>
              </FilterContainer>

              <FilterContainer isOpen={submenuOpen.otherOpen} handleClick={() => {setSubmenuOpen({...submenuOpen, otherOpen: !submenuOpen.otherOpen})}} filterName={t('filters.other.title')} changedFilters={changedFilters} setChangedFilters={setChangedFilters} setSelectedFilters={setSelectedFilters} isLastItem={true} setSaveFilters={setSaveFilters}>
                <OtherFilters displayFiltersClicked={displayFilters} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters} setSaveFilters={setSaveFilters}/>
              </FilterContainer>
            </div>
        </div>
        <div className='filter-buttons-container'>
          <Grid className='filter-buttons' container spacing={2}>
              <Grid item xs={5}>
                  <Button className='btn-grey' onClick={(e) => handleClear(e)}>
                      {t('filters.clear')}
                  </Button>
              </Grid>
              <Grid item xs={7}>
                  <Button className={'btn-blue'} onClick={(e) => handleDisplay(e)}>
                      {t('filters.displayPairings')}
                  </Button>
              </Grid>
          </Grid>
        </div>
      </>
    );
}

export default SideFilterDrawerContainer;
